import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {ReceivablesImportRow} from "../interface/receivables-import-row";
import {ReceivablesStatement} from "../interface/receivables-statement";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {Uuid} from "../interface/response/uuid";
import {ListResponse} from "../interface/response/list-response";
import {Document as DocumentInterface} from "../interface/document";
import {Regional} from "../interface/regional";

@Injectable({
  providedIn: 'root'
})
export class ReceivablesStatementService {
  public readonly receivablesStatementListSubject: ReplaySubject<CountedAndPaginated<ReceivablesStatement>>
    = new ReplaySubject<CountedAndPaginated<ReceivablesStatement>>(1);
  private readonly receivablesStatementDictSubject: ReplaySubject<Array<ReceivablesStatement>>;

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
) {
    this.receivablesStatementDictSubject = new ReplaySubject<Array<ReceivablesStatement>>(1);
    this.loadDict();
  }
  public loadDict(): void {
    this.httpClient.get('/rest/crm/dictionary/receivables-statement')
      .pipe(take(1))
      .subscribe((result: ListResponse<ReceivablesStatement>) => {
        this.receivablesStatementDictSubject.next(result.items);
      });
  }

  public loadList(page: number, pageSize: number, filters: object): void
  {
    this.httpClient.get(`/rest/crm/receivables-statement?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe({
        next: (result: CountedAndPaginated<ReceivablesStatement>) => {
          this.receivablesStatementListSubject.next(result);
        }, error: (error: HttpErrorResponse) => {
          this.receivablesStatementListSubject.error(error);
        }
      });
  }

  public get(receivablesStatementId: string): Observable<ReceivablesStatement> {
    return this.httpClient.get(`/rest/crm/receivables-statement/${receivablesStatementId}`)
      .pipe(first()) as Observable<ReceivablesStatement>;
  }

  downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/receivables-statement/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  sendForm(formData: any, uuid?: string): Observable<Uuid> {
    if (!uuid) {
      return this.httpClient.post(`/rest/crm/receivables-statement`, formData)
        .pipe(first()) as Observable<Uuid>;
    } else {
      return this.httpClient.put(`/rest/crm/receivables-statement/${uuid}`, formData)
        .pipe(first()) as Observable<Uuid>;

    }
  }
  public getStatementReceivablesImportRows(statementId: string): Observable<ListResponse<ReceivablesImportRow>> {
    return this.httpClient.get(`/rest/crm/receivables-statement/${statementId}/receivables-import-rows`)
      .pipe(first()) as Observable<ListResponse<ReceivablesImportRow>>;
  }

  public getReceivablesStatementDictSubject(): ReplaySubject<Array<ReceivablesStatement>> {
    return this.receivablesStatementDictSubject;
  }

  public delete(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/receivables-statement/${uuid}`)
      .pipe(first());
  }

  downloadReportHistory(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/receivables-statement/history/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
}
